export const dayOfTypes = [
  {
    value: 'Day-Off',
    label: 'Day-Off'
  },
  {
    value: 'Team Event',
    label: 'Team Event'
  }
]
